import { Injectable } from '@angular/core';
import { GenericModalsService } from '@anecdotes/design-system/modals';
import { firstValueFrom } from 'rxjs';
import { RoleEnum, RoleService } from '@anecdotes/auth-core';
import { UserFacadeService } from '@anecdotes/identity';

@Injectable()
export class ConfirmationModalService {
  constructor(
    private genericModalsService: GenericModalsService,
    private userFacadeService: UserFacadeService,
    private roleService: RoleService,
  ) {}

  openThreadDeleteConfirmation(): Promise<boolean> {
    return this.genericModalsService.openConfirmationModal({
      confirmTranslationKey: 'commenting.deleteThreadConfirmation.yesBtn',
      dismissTranslationKey: 'commenting.deleteThreadConfirmation.cancelBtn',
      questionTranslationKey: 'commenting.deleteThreadConfirmation.question',
      aftermathTranslationKey: 'commenting.deleteThreadConfirmation.aftermath',
    });
  }

  openReplyDeleteConfirmation(): Promise<boolean> {
    return this.genericModalsService.openConfirmationModal({
      confirmTranslationKey: 'commenting.deleteCommentConfirmation.yesBtn',
      dismissTranslationKey: 'commenting.deleteCommentConfirmation.cancelBtn',
      questionTranslationKey: 'commenting.deleteCommentConfirmation.question',
      aftermathTranslationKey: 'commenting.deleteCommentConfirmation.aftermath',
    });
  }

  openDeleteAllConfirmation(): Promise<boolean> {
    return this.genericModalsService.openConfirmationModal({
      confirmTranslationKey: 'commenting.deleteAllConfirmation.yesBtn',
      dismissTranslationKey: 'commenting.deleteAllConfirmation.cancelBtn',
      questionTranslationKey: 'commenting.deleteAllConfirmation.question',
      aftermathTranslationKey: 'commenting.deleteAllConfirmation.aftermath',
    });
  }

  openResolveAllConfirmation(): Promise<boolean> {
    return this.genericModalsService.openConfirmationModal({
      confirmTranslationKey: 'commenting.resolveAllConfirmation.yesBtn',
      dismissTranslationKey: 'commenting.resolveAllConfirmation.cancelBtn',
      questionTranslationKey: 'commenting.resolveAllConfirmation.question',
      aftermathTranslationKey: 'commenting.resolveAllConfirmation.aftermath',
    });
  }

  async openAuditorMentionModal(messageBody: string): Promise<boolean> {
    const doc: Document = new DOMParser().parseFromString(messageBody, 'text/html');
    const mentionedPerson: HTMLSpanElement | null = doc.querySelector('.person');

    if (mentionedPerson) {
      const mentionedUserName = mentionedPerson.textContent.slice(1); // Remove "@" symbol
      const users = await firstValueFrom(this.userFacadeService.getUsers());
      const isCurrentUserAuditor = await firstValueFrom(this.roleService.isAuditor());

      // TODO - use the mentionedUsers field after developer
      const auditor = users
        .filter((user) => user.role == RoleEnum.Auditor)
        .find((user) => mentionedUserName === `${user.first_name} ${user.last_name}`);

      if (!isCurrentUserAuditor && auditor && !localStorage.getItem('mention-auditor')) {
        return await this.genericModalsService.openConfirmationModal({
          confirmTranslationKey: 'commenting.auditorMentionModal.yesBtn',
          dismissTranslationKey: 'commenting.auditorMentionModal.noBtn',
          questionTranslationKey: 'commenting.auditorMentionModal.description',
          aftermathTranslationKey: 'commenting.auditorMentionModal.aftermath',
          localStorageKey: 'mention-auditor',
          dontShowTranslationKey: 'commenting.auditorMentionModal.dontShow',
        });
      }
    }

    return true;
  }
}
